import { HttpBackend } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { XpoLtlAuthenticationService, XpoLtlAuthGuard } from '@xpo-ltl/ngx-auth';
import { Observable, ReplaySubject } from 'rxjs';
import { tap } from 'rxjs/operators';

/** Keeps application startup behind the library's Firebase login and Firestore setup. */
@Injectable({ providedIn: 'root' })
export class FirestoreAuthGuard extends XpoLtlAuthGuard {
  private readonly authReady = new ReplaySubject<void>(1);
  readonly authReady$ = this.authReady.asObservable();

  // Declare inherited dependencies explicitly for both JIT tests and AOT builds.
  constructor(
    fireAuth: AngularFireAuth,
    authService: XpoLtlAuthenticationService,
    httpBackend: HttpBackend,
    router: Router,
  ) {
    super(fireAuth, authService, httpBackend, router);
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return super.canActivate(route, state).pipe(
      tap((authorized) => {
        if (authorized) {
          this.authReady.next();
        }
      })
    );
  }
}
